import React from 'react';

import { PageTitle } from '../../Text';
import HomeButton from '../HomeButton';

export default () => (
  <div className="success-content">
    <PageTitle>Thank you for using our services</PageTitle>
    <p>
      <span>
        Your request has been sent to our offices to proceed with the renewal of
        the applicant’s blue CPCS competent operator card. Once the card has
        been renewed, the details will be available on the NOCN card checker{' '}
        <a href="https://cpcs.nocn.org.uk/card-checker/">
          cpcs.nocn.org.uk/card-checker
        </a>
        . The card will be sent within 15 days to the mailing address supplied.
      </span>
    </p>
    <HomeButton />
  </div>
);
